import {
  IconBell,
  IconBellGray,
  IconBinocularsGray,
  IconChainLink,
  IconChainLinkGray,
  IconChartBarGray,
  IconChartRadius,
  IconClockGray,
  IconCloudCheckGray,
  IconDashboard,
  IconRoute,
  IconRulerGray,
  IconSearch,
  IconSecurity,
  IconShareGray,
  IconTagGray,
  IconTvocGray,
  IconUserCheck,
  IconWarning,
  IconWarningGray,
  IconZoneGray,
} from '@assets/images/icon';
import { IconTemp } from '@assets/images/main';
import { rtlsSystem } from '@assets/images/solution';
import video from '@src/assets/images/solution/logisticsAsset/video/rtlsVideo.mp4';

import image1 from '@src/assets/images/solution/manufacturingForklift/img/1.avif';
import image2 from '@src/assets/images/solution/manufacturingForklift/img/2.avif';
import image3 from '@src/assets/images/solution/manufacturingForklift/img/3.avif';
import image4 from '@src/assets/images/solution/manufacturingForklift/img/4.avif';
import image5 from '@src/assets/images/solution/manufacturingForklift/img/5.avif';
import image6 from '@src/assets/images/solution/manufacturingForklift/img/6.avif';

export default {
  type: '能源/环境解决方案',

  banner: {
    title: '即使在核电站也不遗漏的叉车位置追踪系统',
    desc: '通过UWB位置技术追踪叉车移动，并自动保存废物运输路径，同时实现对监管机构的合规应对与资产安全加强。',
  },

  video: {
    title: '强大结构，微弱信号。ORBRO 突破这一限制。',
    desc: '即使在被钢板覆盖的空间和10米以上的高天花板内，ORBRO的位置追踪技术也能准确接收信号。发电站内的资产何时、何地、由谁搬运，都可以通过数据进行证明。',
    play: video,
  },

  func: [
    {
      theme: '极端环境下无间断高精度追踪',
      title: '金属密闭结构中也能稳定获取位置信息',
      desc: '在被金属结构包围的封闭空间中，ORBRO位置追踪系统依然保持无信号丢失的稳定性能。在传统TDoA无法追踪的环境下，也能提供±30cm以内的精确位置信息。',
      sub1: '提供高精度',
      icon1: IconRulerGray,
      sub2: '快速数据联动',
      icon2: IconShareGray,
      image: image1,
    },
    {
      title: '适用于高天花板',
      desc: '即使是在10米以上高天花板的空间中，也能准确识别位置。只需最少的基础设施即可覆盖大范围区域，提升安装效率与运营便利性。',
      sub1: '指定高风险资产',
      icon1: IconWarningGray,
      sub2: '设置应对方式',
      icon2: IconBellGray,
      image: image2,
    },
    {
      title: '高速移动与复杂路线也能无缝接收',
      desc: '即使叉车快速移动或在狭窄区域重复行驶，所有路线也会无丢失地准确记录。在室内反射环境下也能保证数据连续性。',
      sub1: '提供高精度',
      icon1: IconRulerGray,
      sub2: '快速数据联动',
      icon2: IconChainLinkGray,
      image: image3,
    },
    {
      theme: '精准算法与历史记录驱动的运营优化',
      title: '采用Advanced TDoA高精度算法',
      desc: '通过时间同步、时钟误差校正、最小二乘法位置计算等6步精密处理，即使在复杂环境中也能计算出准确位置。凭借ORBRO独有技术，实现了工业现场所需的高精度与稳定性。',
      sub1: '提供统计数据',
      icon1: IconChartBarGray,
      sub2: '云端数据保存',
      icon2: IconCloudCheckGray,
      image: image4,
    },
    {
      title: 'Multipath/NLOS环境滤波',
      desc: '自动剔除信号反射或非视距(NLOS)条件下产生的失真数据，提供基于真实路径的精准位置。在Multipath环境下也可保持98%以上的位置成功率。',
      sub1: '提供统计数据',
      icon1: IconChartBarGray,
      sub2: '云端数据保存',
      icon2: IconCloudCheckGray,
      image: image5,
    },
    {
      title: '叉车移动历史时间线管理',
      desc: '叉车的移动路线和位置变化会按时间顺序保存，可分析特定区域的停留时间或路线偏离。',
      sub1: '提供统计数据',
      icon1: IconChartBarGray,
      sub2: '云端数据保存',
      icon2: IconCloudCheckGray,
      image: image6,
    },
  ],

  subfunc: {
    title: '多样化功能',
    desc: '医疗废物的管理不能有丝毫松懈。即使是小小的疏忽或失误，也可能导致严重的医疗事故。因此，需要极其精密的管理和严格的安全保障。<br/>ORBRO 提供多种功能，助力建设安全高效的医疗设施。',

    data: [
      {
        icon: IconZoneGray,
        title: '金属空间追踪',
        desc: '高棚金属封闭也稳定追踪。',
      },
      {
        icon: IconRulerGray,
        title: 'ATDoA高精度',
        desc: '高速车±50cm实时定位。',
      },
      {
        icon: IconChainLink,
        title: '内置Multipath/NLOS',
        desc: '复杂结构也最小误差。',
      },
      {
        icon: IconDashboard,
        title: '实时叉车可视化',
        desc: '叉车位置实时看板展示。',
      },
      {
        icon: IconRoute,
        title: '移动轨迹记录',
        desc: '保存并显示时间轴轨迹。',
      },
      {
        icon: IconBinocularsGray,
        title: '高速连续追踪',
        desc: '高速车辆不断信号追踪。',
      },
      {
        icon: IconChartRadius,
        title: '审计数据支持',
        desc: '历史数据可审计用。',
      },
      {
        icon: IconWarning,
        title: '出入自动检测',
        desc: '关键区自动记录出入。',
      },
      {
        icon: IconBell,
        title: '异常停留报警',
        desc: '超时停留自动通知管理员。',
      },
      {
        icon: IconRoute,
        title: '防撞动线监控',
        desc: '分析路径防止冲突。',
      },
    ],
  },

  system: {
    title: '系统结构',
    img: rtlsSystem,
  },

  productTitle: '产品组成',
  product: [{ tag: 'assetPackage' }, { tag: 'workerPackage' }],

  contents: [{ data: 'medicalPatient' }, { data: 'retailOffice' }, { data: 'blogMedical' }, { data: 'blogRTLS' }],
};
